/* Copyright (c) 2022 MOCA Systems, Inc. All rights reserved. */

export enum BreakUpBy {
	Off = 'off',
	Role = 'role',
}
